import { render, staticRenderFns } from "./LateralNav.vue?vue&type=template&id=cb6fb350&scoped=true&"
import script from "./LateralNav.vue?vue&type=script&lang=js&"
export * from "./LateralNav.vue?vue&type=script&lang=js&"
import style0 from "./LateralNav.vue?vue&type=style&index=0&id=cb6fb350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6fb350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VDivider,
  VIcon,
  VList,
  VListTileAction,
  VNavigationDrawer,
  VTooltip,
})
